export default "__VITE_ASSET__Dvc3Le2I__"